/**
 * Variant picker for products where add to cart is disabled (quote / finance).
 * Keeps the URL, the price block and the Approve finance button in sync with
 * the selected variant. The Storeify quote popup reads ?variant= from the URL
 * to preselect the variant.
 */
(function () {
  if (window.__variantPickerOnlyLoaded) return;
  window.__variantPickerOnlyLoaded = true;

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    const value = (cents / 100).toFixed(precision);
    const parts = value.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
    return parts[1] ? dollars + decimal + parts[1] : dollars;
  }

  function formatMoney(cents, format) {
    const fmt = format || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return formatWithDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator':
          return formatWithDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return formatWithDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return formatWithDelimiters(cents, 2, "'", '.');
        default:
          return formatWithDelimiters(cents, 2, ',', '.');
      }
    });
  }

  function updateUrl(variant) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState(window.history.state, '', url.toString());
  }

  function updatePrice(scope, variant, moneyFormat) {
    scope.querySelectorAll('[data-product-pricing] [data-price-container] [data-price]').forEach(el => {
      el.textContent = formatMoney(variant.price, moneyFormat);
    });
  }

  // Approve watches these attributes (MutationObserver) and recalculates the
  // teaser rate and the app payload itself, so only the attributes are set.
  function updateFinance(scope, variant, moneyFormat) {
    const price = formatMoney(variant.price, moneyFormat);

    scope.querySelectorAll('[approve-function="embedded_app"]').forEach(button => {
      if (!button.hasAttribute('data-approve-model-base')) {
        button.setAttribute('data-approve-model-base', button.getAttribute('approve-model') || '');
      }
      const model = `${button.getAttribute('data-approve-model-base')} - ${variant.title}`;

      if (button.getAttribute('approve-model') !== model) {
        button.setAttribute('approve-model', model);
      }
      if (button.getAttribute('approve-price') !== price) {
        button.setAttribute('approve-price', price);
      }
    });

    scope.querySelectorAll('[approve-function="teaser_rate"]').forEach(teaser => {
      if (teaser.getAttribute('approve-total') !== price) {
        teaser.setAttribute('approve-total', price);
      }
    });
  }

  // The Storeify popup only preselects a variant when its trigger button sits
  // inside `.storeify-button-detail`, which our custom quote buttons are not.
  // It rebuilds its variant dropdown on every open, so wait for it and
  // preselect the variant chosen in the picker.
  function syncQuotePopup(selection, trigger) {
    const variantId = selection.variant;
    const target = document.querySelector(trigger.getAttribute('data-target'));
    if (!variantId || !target) return;

    const apply = () => {
      const select = target.querySelector('#storeify_option_variants');
      if (!select || !select.querySelector(`option[value="${variantId}"]`)) return false;
      if (select.value !== variantId) {
        select.value = variantId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    };

    const observer = new MutationObserver(() => {
      if (apply()) observer.disconnect();
    });
    observer.observe(target, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 10000);
  }

  function init(picker) {
    if (picker.dataset.variantPickerOnlyInit) return;
    picker.dataset.variantPickerOnlyInit = 'true';

    const selection = picker.querySelector('variant-selection');
    if (!selection) return;

    const scope = picker.closest('[data-product-wrapper]') || document;
    const moneyFormat = picker.dataset.moneyFormat;

    selection.addEventListener('variant-change', event => {
      const { variant } = event.detail;
      if (!variant) return;

      updateUrl(variant);
      updatePrice(scope, variant, moneyFormat);
      updateFinance(scope, variant, moneyFormat);
    });

    scope.addEventListener('click', event => {
      const trigger = event.target.closest('.storeify-quote-btn-trigger-popup');
      if (trigger) syncQuotePopup(selection, trigger);
    });

    // Initial sync: the finance button is rendered with the lowest variant
    // price, but the page may load with another variant selected (?variant=).
    customElements
      .whenDefined('variant-selection')
      .then(() => selection.getVariant())
      .then(variant => {
        if (!variant) return;
        updatePrice(scope, variant, moneyFormat);
        updateFinance(scope, variant, moneyFormat);
      });
  }

  function initAll() {
    document.querySelectorAll('[data-variant-picker-only]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
